function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  fill: "#7E7E7E",
  d: "M20.3,161.2c-2.2,16.6-4.3,32.3-6.4,48.6c8.9-1.2,17.5-2.3,26.2-3.4c2.6-0.3,5.3-0.7,7.9-1 c3.5-0.3,5.9,1.4,6.7,4.7c1,3.6-0.6,6.5-4.1,7.5c-4.2,1.1-8.5,1.6-12.8,2.2c-9.2,1.3-18.5,2.5-27.7,3.8c-7.7,1.1-11-2.2-10-9.8 c3-21.6,5.8-43.2,8.9-64.8c0.4-2.8,1.8-5.9,3.8-7.8C55.3,98.4,97.8,55.8,140.4,13.4c17.8-17.7,49.4-17.8,67.3-0.7 c20.5,19.6,21.7,49.6,2.8,70.4c-3.1,3.4-6.5,6.6-9.8,9.9c-38.8,38.7-77.6,77.5-116.4,116.2c-6.7,6.7-8.4,6.7-15.1,0.1 c-14.9-14.8-29.8-29.6-44.7-44.4C23.4,163.9,22.1,162.8,20.3,161.2z M161.7,52c-6.7-6.7-13.7-13.7-20.2-20.3 C103.2,70,64.5,108.8,26,147.3c6.7,6.7,13.7,13.8,20.2,20.3C84.9,128.9,123.7,90,161.7,52z M75.8,197.4 c38.8-38.8,77.7-77.7,115.8-115.8c-6.2-6.2-13-12.9-18.8-18.7C134.5,101.2,95.7,140,57.1,178.6C63.2,184.8,69.9,191.5,75.8,197.4z  M152.5,20.6c17,17,33.9,33.9,50.7,50.7c11.2-13.7,10.2-34.8-2.6-47.7C187.3,10.4,166.1,9.3,152.5,20.6z"
}), /*#__PURE__*/React.createElement("polyline", {
  fill: "#7E7E7E",
  points: "40.1,206.4 63.6,203.9 76.1,214.3 40.1,219.5 40.1,207.5  "
}));

var SvgIconEdit = function SvgIconEdit(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    width: "223.9px",
    height: "223.8px",
    viewBox: "0 0 223.9 223.8",
    enableBackground: "new 0 0 223.9 223.8",
    xmlSpace: "preserve",
    ref: svgRef
  }, props), _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconEdit, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon-edit.b62dee37.svg";
export { ForwardRef as ReactComponent };